import { SvrConn } from "../utils/axios/index";
/**
 * Metodo que actualiza el turno a pendiente
 */
const setTurnoPendiente = async (TurnoId, ItemId, PeriodoId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/turno/setturnopendiente", {
      TurnoId,
      ItemId,
      PeriodoId,
    });
  } catch (Error) {
    res = Error;
  }
  return res;
};

//-----
const setTurnoAtendido = async (TurnoId, ItemId, PeriodoId, Profesional) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/turno/setturnoatendido", {
      TurnoId,
      ItemId,
      PeriodoId,
      Profesional,
    });
  } catch (Error) {
    res = Error;
  }
  return res;
};

//------
const getTurnoxItemId = async (TurnoId, ItemId, PeriodoId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/turno/getturnoxitem", {
      TurnoId,
      ItemId,
      PeriodoId,
    });
  } catch (Error) {
    res = Error;
  }
  return res;
};

//-------------------------------------------------------
const getTurnomedxItemId = async (TurnoId, ItemId, PeriodoId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/turno/getturnomedxitem", {
      TurnoId,
      ItemId,
      PeriodoId,
    });
  } catch (Error) {
    res = Error;
  }
  return res;
};

//-------------------------------------------------------
const getSolicitaTurnMedPend = async (PeriodoId, TurnoId, ItemId, AreaId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/turno/getsolicitarturnmedpend", {
      PeriodoId,
      TurnoId,
      ItemId,
      AreaId,
    });
  } catch (Error) {
    res = Error;
  }
  return res;
};

//-------
const setTurnoMedAtendido = async (TurnoId, ItemId, PeriodoId, AreaId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/turno/setturnomedatendido", {
      TurnoId,
      ItemId,
      PeriodoId,
      AreaId
    });
  } catch (Error) {
    res = Error;
  }
  return res;
};

//-------
const setTurnoMedPendiente = async (TurnoId, ItemId, PeriodoId, AreaId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/turno/setturnomedpendiente", {
      TurnoId,
      ItemId,
      PeriodoId,
      AreaId
    });
  } catch (Error) {
    res = Error;
  }
  return res;
};



export { setTurnoPendiente, setTurnoAtendido, getTurnoxItemId, getSolicitaTurnMedPend, setTurnoMedAtendido, setTurnoMedPendiente, getTurnomedxItemId };
